import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  inject,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ExtractFormControl } from 'app/utils/validator.utils';
import {
  MetricSettings,
  WidgetPredictiveOptions,
} from '../widget-predictive/widget-predictive.component';
import { MetricSettingsFormComponent } from './metric-settings-form/metric-settings-form.component';

interface MetricSettingsModalForm {
  main: FormControl<MetricSettings>;
  driver: FormControl<MetricSettings>;
}

export type MetricSettingsModalResult = ExtractFormControl<MetricSettingsModalForm>;

@EnableClassTelemetry()
@Component({
  selector: 'app-metric-settings-modal',
  imports: [AppSharedModule, MetricSettingsFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './metric-settings-modal.component.html',
  styleUrl: './metric-settings-modal.component.scss',
})
export class MetricSettingsModalComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() predictiveOptions!: WidgetPredictiveOptions;

  @Output() close = new EventEmitter<MetricSettingsModalResult | null>();

  form: FormGroup<MetricSettingsModalForm>;

  private readonly formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.form = this.formBuilder.group<MetricSettingsModalForm>({
      main: new FormControl(this.predictiveOptions.mainSettings),
      driver: new FormControl(this.predictiveOptions.driverSettings),
    });
  }

  onApply(): void {
    const formValue = this.form.getRawValue();
    this.close.emit(formValue);
  }

  onCancel(): void {
    this.close.emit(null);
  }
}
